import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getCheckToken = async ({ token }) => {
  const { data } = await SigliveServiceV1({ method: 'GET', url: `/check-token/${token}` });
  return data;
};

export default getCheckToken;
